import {Button, Card, Collapse, InputGroup} from '@blueprintjs/core';
import {useState} from 'react';
import {signin} from '../services/api-handler';
import {useNavigate} from 'react-router-dom';

export default function Login() {
     const [username, setUsername] = useState('');
     const [password, setPassword] = useState('');
     const [showNote, setShowNote] = useState(false);
     const navigate = useNavigate();
     const login = async (e) => {
          const loginData = {
               username: username,
               password: password
          };
          try {
               const loggedIn = await signin(loginData);
               console.log(loggedIn);
               if (loggedIn === 200) {
                    navigate('/main');
               }
          } catch (error) {
               console.log('error ' + error);
               setShowNote(true);
          }
     };

     return (
          <div className="login-wrapper">
               <Card className="bp5-interactive">
                    <form>
                         <h2>FMLX HR Tools</h2>
                         <hr />
                         <div>
                              <InputGroup
                                   onChange={(e) => {
                                        setUsername(e.target.value);
                                        setShowNote(false);
                                   }}
                                   className="space-top"
                                   type="text"
                                   name="username"
                                   placeholder="Email SIK"
                              />
                              <InputGroup
                                   onChange={(e) => {
                                        setPassword(e.target.value);
                                        setShowNote(false);
                                   }}
                                   className="space-top"
                                   type="password"
                                   name="password"
                                   placeholder="Kata Sandi SIK"
                                   autoComplete="current-password"
                              />
                              <Button type="button" onClick={login} className="space-top" large>
                                   Masuk
                              </Button>
                         </div>
                    </form>
               </Card>
               <Collapse isOpen={showNote}>
                    <div className="bp5-elevation-2" style={{backgroundColor: '#CD4246', color: 'wheat', padding: '5px'}}>
                         Login Gagal
                    </div>
               </Collapse>
          </div>
     );
}
